// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".advice__items-outer[data-v-012055d0]{overflow:hidden;width:auto;scroll-behavior:smooth}.advice__items-inner[data-v-012055d0]{display:flex}.advice__item[data-v-012055d0]{overflow:hidden}.advice .table[data-v-012055d0]{font-size:1.7rem;margin-bottom:20px}.advice .table td[data-v-012055d0]{padding:8px}", ""]);
// Exports
module.exports = exports;
